import moment from 'moment';
import { ICompany } from '../interfaces/company.interface';

export const formatDate = (date?: string, formatDate?: string) => {
  return moment(date)
    .utc()
    .format(formatDate ?? 'DD/MM/YYYY');
};

export const getStringDateCity = (company: ICompany, issueDate?: string) => {
  const date = !issueDate ? new Date() : new Date(`${issueDate}`);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];
  return (
    company.city +
    '-' +
    company.state +
    ', ' +
    day +
    ' de ' +
    months[month] +
    ' de ' +
    year
  );
};

export const getInitialFinalDateMonth = () => {
  const date = new Date();
  const primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
  const ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const dateI =
    date.getFullYear() +
    '-' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('00' + primeiroDia.getDate()).slice(-2);
  const dateF =
    date.getFullYear() +
    '-' +
    ('00' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('00' + ultimoDia.getDate()).slice(-2);

  return { dateI, dateF };
};

export const differenceInDays = (
  dateLeft: Date | number,
  dateRight: Date | number,
): number => {
  const leftDate = new Date(dateLeft);
  const rightDate = new Date(dateRight);
  leftDate.setHours(0, 0, 0, 0);
  rightDate.setHours(0, 0, 0, 0);
  const MS_PER_DAY = 1000 * 60 * 60 * 24;
  const differenceInMs = leftDate.getTime() - rightDate.getTime();
  return Math.round(differenceInMs / MS_PER_DAY);
};
